import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { PhonicsLesson } from '@/api/types';
import { useLessonPlayer } from '@/context/LessonPlayer';
import { CarouselSlide } from '../../Carousel';
import { Character, PillButton } from '@/components/lessonKit';

interface LearningLinkProps {
  lesson: PhonicsLesson;
}

export const LearningLink = ({ lesson }: LearningLinkProps) => {
  const router = useRouter();
  const { registerSlide } = useLessonPlayer();

  useEffect(() => {
    registerSlide('learning-link');
  }, [registerSlide]);

  return (
    <CarouselSlide
      identifier="learning-launcher"
      className="relative flex flex-col justify-center items-center px-12 bg-[var(--c-write)]"
      classNameInner="flex-grow w-[760px] max-h-[500px] xl:w-[960px] xl:max-h-[800px] 2xl:w-[1280px]"
    >
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage:
            'radial-gradient(circle at 12% 18%, rgba(255,255,255,0.07) 0, transparent 200px),' +
            'radial-gradient(circle at 88% 78%, rgba(255,255,255,0.07) 0, transparent 200px)',
        }}
      />

      <div className="relative flex flex-col items-center gap-8">
        <Character pose="teacher" width="min(24vw,300px)" animate="none" />

        <h1
          className="text-center text-6xl uppercase tracking-wide text-white"
          style={{ fontFamily: 'var(--lp-display), Impact, sans-serif' }}
        >
          Time to spell!
        </h1>

        <PillButton
          size="lg"
          glyph="✏️"
          color="var(--c-write)"
          onClick={() => router.push(`/play/${lesson.id}?kind=spelling`)}
        >
          LAUNCH SPELLING
        </PillButton>
      </div>
    </CarouselSlide>
  );
};
